import { KeyRound } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toastService from '../../services/toastService';
import { useForgetPasswordMutation } from '../../app/services/authApi';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [forgetPassword, { isLoading }] = useForgetPasswordMutation();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toastService.error('Please enter your email');
      return;
    }
    try {
      await forgetPassword({ email }).unwrap();
      toastService.success('Password reset link sent to your email!');
      navigate('/login');
    } catch (error) {
      toastService.error(error.data?.message || 'Failed to send reset link, try again.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center secondary-background relative">
      <div className="max-w-md w-full tertiary-background backdrop-blur-xl p-8 rounded-2xl shadow-2xl border border-white/40 space-y-6">
        <h2 className="text-xl font-bold text-center text-primary">Forgot Password</h2>

        <div className="h-20 w-20 mx-auto mb-6 secondary-background rounded-full flex items-center justify-center">
          <KeyRound size={32} className=" text-primary" />
        </div>
        <p className="text-sm text-secondary text-center">
          Enter your email address and we’ll send you a link to reset your password.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 border-color shadow-sm"
          />
          <div>
            <button
              type="submit"
              disabled={isLoading}
              className="w-full px-4 mt-2 py-2 rounded-lg text-sm font-medium white-text primary-background hover:opacity-90 transition-all duration-200 shadow-md"
            >
              {isLoading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </div>
        </form>
        <div>
          {/* <p className="text-sm text-center">Remembered your password? </p> */}
          <p
            onClick={() => navigate('/login')}
            className="text-primary hover:underline cursor-pointer flex justify-center mt-3"
          >
            Back to Login
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
